import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx.js";

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  actions?: ReactNode;
  /** Remove body padding (tables inside cards). */
  flush?: boolean;
  children: ReactNode;
}

export function Card({ title, actions, flush = false, className, children, ...rest }: CardProps) {
  return (
    <section className={cx("card", flush && "card--flush", className)} {...rest}>
      {title || actions ? (
        <header className="card__header">
          {title ? <h3 className="card__title">{title}</h3> : <span />}
          {actions}
        </header>
      ) : null}
      <div className="card__body">{children}</div>
    </section>
  );
}
